import { Extension } from '@tiptap/core'
import { Plugin } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

export interface EmptyPlaceholderOptions {
  /** Hint text shown while the editor has no content — the input-`placeholder` equivalent. */
  placeholder?: string
}

/**
 * Renders `placeholder` as greyed-out hint text while the doc is empty, by tagging the first node
 * with `is-editor-empty` + `data-placeholder` (styled in useEditorStyles).
 *
 * Note: unrelated to TemplatePlaceholderMark, which handles `{{templateTags}}`. This is a local
 * trimmed-down stand-in for @tiptap/extension-placeholder, which isn't a dependency here.
 */
export const EmptyPlaceholder = Extension.create<EmptyPlaceholderOptions>({
  name: 'emptyPlaceholder',

  addOptions() {
    return { placeholder: '' }
  },

  addProseMirrorPlugins() {
    const { editor, options } = this

    return [
      new Plugin({
        props: {
          decorations: (state) => {
            if (!options.placeholder || !editor.isEditable || !editor.isEmpty) return null

            const firstNode = state.doc.firstChild
            if (!firstNode) return null

            return DecorationSet.create(state.doc, [
              Decoration.node(0, firstNode.nodeSize, {
                class: 'is-editor-empty',
                'data-placeholder': options.placeholder
              })
            ]) as any
          }
        }
      })
    ]
  }
})
